/* eslint-disable comma-dangle, max-len, no-console, padded-blocks */
/* This mixin provides methods for getting form schemas */
import moment from 'moment';

export default {
  methods: {
    validateRegexAnimal(value) {
      if (value == null || Number.isNaN(value)) return [];
      if (value === 0) return ['Positive non-zero integers only'];

      const regex = /^[1-9][0-9]{0,4}$/;

      if (!regex.test(value)) {
        return ['Positive non-zero integers only, max of 5 digits'];
      }

      return [];
    },
    getFirstSiteVisitSchema() {
      const schema = {
        groups: [
          this.getGeneralDetails(),
          this.getPropertyAccess(),
          this.$store.state.SiteVisit.invasives,
          this.getAgriculturalDetails(),
          this.getForestDetails(),
          this.getStreamDetails(),
          this.getHabitatDetails(),
          this.getUrbanDetails(),
          this.getTechnicalAssistance(),
        ]
      };

      return schema;
    },

    getGeneralDetails() {
      return {
        legend: 'General',
        headerName: 'General',
        fields: [
          {
            type: 'customTextlist',
            label: '<span class="label-name">Related Contacts</span>',
            model: 'generalDetails.relatedContacts',
            styleClasses: 'row',
          },
          {
            type: 'input',
            inputType: 'text',
            label: '<span class="label-name">Visited By</span>',
            model: 'generalDetails.visitedBy',
            styleClasses: 'row',
          },
          {
            type: 'customDatepicker',
            label: '<span class="label-name">Date of Visit</span>',
            placeholder: 'Select Date of Visit',
            model: 'generalDetails.dateOfVisit',
            disabledDates: {
              from: moment().toDate(),
            },
            styleClasses: 'row',
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Other Parties Present</span><br/><span class="help-text">(Max 100 characters)</span>',
            model: 'generalDetails.otherPartiesPresent',
            max: 100,
            attributes: {
              wrapper: { 'data-list': 'col-5' },
            },
            styleClasses: 'row',
          },
          {
            type: 'radios',
            label: '<span class="label-name">Operator has knowledge of the project?</span><br/><span class="help-text">(Select one)</span>',
            model: 'generalDetails.operatorHasKnowledgeOfTheProject',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
              'N/A',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Landowner preferred form of contact</span><br/><span class="help-text">(Select one)</span>',
            model: 'generalDetails.landownerPreferredFormOfContact',
            styleClasses: 'row',
            values: [
              'Email',
              'Home phone',
              'Cell phone call',
              'Cell phone text',
              'Postal mail'
            ]
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Landowner Resource Priorities</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'generalDetails.landownerResourcePriorities',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Water Quality',
              'Soil Health',
              'Water Quantity',
              'Fish and Wildlife Habitat',
              'Invasive Species',
              'Forest Health',
              'Farmland Protection',
              'Air Quality',
              'Informed and Involved Public'
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Landowner Goals</span><br/><span class="help-text">(Max 250 characters)</span>',
            model: 'generalDetails.landownerGoals',
            styleClasses: 'row',
            max: 250
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Enrollment in other programs</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'generalDetails.enrollmentInOtherPrograms',
            listbox: true,
            styleClasses: 'row',
            values: [
              'TSWCD',
              'CWS',
              'BHCP',
              'Xerces',
              'NWF',
              'NRCS',
              'FSA',
              'Conservation easement',
              'Other - see notes'
            ]
          },
          {
            type: 'radios',
            label: '<span class="label-name">Comfortable with herbicide use?</span><br/><span class="help-text">(Select one)</span>',
            model: 'generalDetails.comfortableWithHerbicideUse',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
              'N/A'
            ]
          },
          {
            type: 'select',
            label: '<span class="label-name">Primary Land Use</span><br/><span class="help-text">(Select one)</span>',
            model: 'generalDetails.primaryLandUse',
            styleClasses: 'row',
            values: [
              'Berries',
              'Christmas Trees',
              'Commercial',
              'Cropland',
              'Dairy',
              'Grass Seed',
              'Horses',
              'Industrial Timber',
              'Livestock',
              'Natural Area',
              'Nursery',
              'Oak',
              'Orchard',
              'Park',
              'Public',
              'Residential',
              'Right of Way',
              'Riparian',
              'Small Woodland',
              'Wetland'
            ]
          },
          {
            type: 'select',
            label: '<span class="label-name">Secondary Land Use</span><br/><span class="help-text">(Select one)</span>',
            model: 'generalDetails.secondaryLandUse',
            styleClasses: 'row',
            values: [
              'Berries',
              'Christmas Trees',
              'Commercial',
              'Cropland',
              'Dairy',
              'Grass Seed',
              'Horses',
              'Industrial Timber',
              'Livestock',
              'Natural Area',
              'Nursery',
              'Oak',
              'Orchard',
              'Park',
              'Public',
              'Residential',
              'Right of Way',
              'Riparian',
              'Small Woodland',
              'Wetland'
            ]
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Property Water Features</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'generalDetails.propertyWaterFeatures',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Stream',
              'Pond',
              'Wetland'
            ]
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Water Rights</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'generalDetails.waterRights',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Surface Water',
              'Groundwater',
              'Storage',
              'TVID Box',
              'TVID Surface Water',
              'None',
              'Unknown'
            ]
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate any easements</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'generalDetails.otherEasements',
            listbox: true,
            styleClasses: 'row',
            values: [
              'TVID',
              'BPA',
              'NW Natural',
              'PGE',
              'CWS',
              'Other - see notes'
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">General Notes</span><br/><span class="help-text">(Max 500 characters)</span>',
            model: 'generalDetails.notes',
            styleClasses: 'row',
            max: 500
          }
        ]
      };
    },
    getPropertyAccess() {
      return {
        legend: 'Property Access',
        headerName: 'Property Access',
        fields: [
          {
            type: 'radios',
            label: '<span class="label-name">Trespassing Issues</span><br/><span class="help-text">(Select one)</span>',
            model: 'propertyAccess.trespassingIssues',
            styleClasses: 'row',
            values: [
              'None',
              'Yes',
              'Unknown'
            ]
          },
          {
            type: 'radios',
            label: '<span class="label-name">Types of Shooting/Hunting</span><br/><span class="help-text">(Select one)</span>',
            model: 'propertyAccess.typesOfShootingHunting',
            styleClasses: 'row',
            values: [
              'None',
              'Waterfowl',
              'Other shooting/hunting'
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Describe Potential Hazards</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'propertyAccess.describePotentialHazards',
            styleClasses: 'row',
            max: 150
          },
          {
            type: 'radios',
            label: '<span class="label-name">Adjacent properties under conservation?</span><br/><span class="help-text">(Select one)</span>',
            model: 'propertyAccess.adjacentPropertiesUnderConservation',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
              'Unknown'
            ]
          },
          {
            type: 'radios',
            label: '<span class="label-name">Neighbor interest in conservation project enrollment?</span><br/><span class="help-text">(Select one)</span>',
            model: 'propertyAccess.neighborInterestInConservationProjectEnrollment',
            styleClasses: 'row',
            values: [
              'No',
              'Yes',
              'Unknown',
              'Landowner will ask'
            ]
          },
          {
            type: 'radios',
            label: '<span class="label-name">Dogs on site?</span><br/><span class="help-text">(Select one)</span>',
            model: 'propertyAccess.dogsOnSite',
            styleClasses: 'row',
            values: [
              'No',
              'Yes'
            ]
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Measures for ensuring contractors/volunteers are safe with respect to dogs?</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'propertyAccess.dogSafetyMeasures',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Dog(s) will be kept inside',
              'Dog(s) will be fenced',
              'Dog(s) will be leashed'
            ],
            visible: (model) => model && model.propertyAccess && model.propertyAccess.dogsOnSite === 'Yes'
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Property Access Notes</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'propertyAccess.notes',
            styleClasses: 'row',
            max: 150
          }
        ]
      };
    },
    getAgriculturalDetails() {
      return {
        legend: 'Agriculture',
        headerName: 'Agriculture',
        fields: [
          {
            type: 'radios',
            label: '<span class="label-name">Has owner/operator been farming fewer than 10 years?</span><br/><span class="help-text">(Select one)</span>',
            model: 'agriculturalDetails.farmedLessThanTenYears',
            styleClasses: 'row',
            values: ['Yes', 'No', 'Other - see notes'],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Owner/Operator Agricultural Management Goals</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'agriculturalDetails.agriculturalManagementGoals',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Improving irrigation efficiency',
              'Extending the growing season',
              'Capturing and irrigating with rain water',
              'Improving pasture condition/usage',
              'Managing mud and manure',
              'Managing erosion',
              'Managing flooding/drainage',
              'Managing beaver',
              'Improving soil health',
              'Enhancing wildlife habitat',
              'Enhancing pollinator habitat',
              'Controlling invasive species',
              'Maintaining or building a pond',
              'Passing on the property to children',
              'Other'
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Describe other Agricultural Management Goals</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'agriculturalDetails.otherAgriculturalManagementGoals',
            styleClasses: 'row',
            max: 150
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Crops being grown</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'agriculturalDetails.cropsBeingGrown',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Grass seed',
              'Berries',
              'Hazelnuts',
              'Annual row crops',
              'Mixed vegetables (small farm/direct market)',
              'Orchard/Vineyard',
              'Christmas trees',
              'Pasture',
              'Hay',
              'Nursery stock',
              'Other - see notes'
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Farming method</span><br/><span class="help-text">(Select one)</span>',
            model: 'agriculturalDetails.farmingMethod',
            styleClasses: 'row',
            values: ['Organic', 'Conventional', 'Mix of organic and conventional'],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Irrigation method(s)</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'agriculturalDetails.irrigationMethods',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Big gun',
              'Overhead sprinkler',
              'Micro/drip',
              'Linear',
              'Unknown',
              'None'
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Landowner interest in irrigation efficiencies and/or updates</span><br/><span class="help-text">(Select one)</span>',
            model: 'agriculturalDetails.irrigationEfficienciesInterest',
            styleClasses: 'row',
            values: ['Yes', 'No', 'Needs more information'],
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Describe fertilizer schedule in use</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'agriculturalDetails.fertilizerScheduleDescription',
            styleClasses: 'row',
            max: 150
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Describe types of fertilizer in use</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'agriculturalDetails.fertilizerTypeDescription',
            styleClasses: 'row',
            max: 150
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Describe livestock manure management in use</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'agriculturalDetails.manureManagementDescription',
            styleClasses: 'row',
            max: 150
          },
          {
            type: 'label',
            label: '<span class="label-name">Indicate number of livestock raised on site (leave blank if none)</span>',
            styleClasses: ['field-label-override-margin row'],
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Cattle</span>',
            styleClasses: ['nested-field-label row'],
            model: 'agriculturalDetails.livestockRaisedOnSiteCattle',
            validator: (value) => (this.validateRegexAnimal(value))
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Horses</span>',
            styleClasses: ['nested-field-label row'],
            model: 'agriculturalDetails.livestockRaisedOnSiteHorses',
            validator: (value) => (this.validateRegexAnimal(value))
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Chickens</span>',
            styleClasses: ['nested-field-label row'],
            model: 'agriculturalDetails.livestockRaisedOnSiteChickens',
            validator: (value) => (this.validateRegexAnimal(value))
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Sheep</span>',
            styleClasses: ['nested-field-label row'],
            model: 'agriculturalDetails.livestockRaisedOnSiteSheep',
            validator: (value) => (this.validateRegexAnimal(value))
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Turkeys</span>',
            styleClasses: ['nested-field-label row'],
            model: 'agriculturalDetails.livestockRaisedOnSiteTurkeys',
            validator: (value) => (this.validateRegexAnimal(value))
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Goats</span>',
            styleClasses: ['nested-field-label row'],
            model: 'agriculturalDetails.livestockRaisedOnSiteGoats',
            validator: (value) => (this.validateRegexAnimal(value))
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Alpacas</span>',
            styleClasses: ['nested-field-label row'],
            model: 'agriculturalDetails.livestockRaisedOnSiteAlpacas',
            validator: (value) => (this.validateRegexAnimal(value))
          },
          {
            type: 'input',
            inputType: 'number',
            label: '<span class="label-name">Other</span>',
            styleClasses: ['nested-field-label row'],
            model: 'agriculturalDetails.livestockRaisedOnSiteOther',
            validator: (value) => (this.validateRegexAnimal(value))
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Time/season in pasture?</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'agriculturalDetails.timeSeasonInPasture',
            styleClasses: 'row',
            max: 150
          },
          {
            type: 'radios',
            label: '<span class="label-name">Livestock off-channel watering needed?</span><br/><span class="help-text">(Select one)</span>',
            model: 'agriculturalDetails.livestockOffChannelWatering',
            styleClasses: 'row',
            values: ['Yes', 'No'],
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Agricultural Notes</span><br/><span class="help-text">(Max 500 characters)</span>',
            model: 'agriculturalDetails.notes',
            styleClasses: 'row',
            max: 500
          },
        ],
      };
    },
    getForestDetails() {
      return {
        legend: 'Forest',
        headerName: 'Forest',
        fields: [
          {
            type: 'radios',
            label: '<span class="label-name">Does Landowner have a forest stewardship plan?</span><br/><span class="help-text">(Select one)</span>',
            model: 'forestDetails.stewardshipPlanExists',
            styleClasses: 'row',
            values: ['Yes', 'No']
          },
          {
            type: 'radios',
            label: '<span class="label-name">Is Landowner interested in having a forest stewardship plan?</span><br/><span class="help-text">(Select one)</span>',
            model: 'forestDetails.stewardshipPlanInterest',
            styleClasses: 'row',
            values: ['Yes', 'No', 'Needs more information'],
            required: true,
            validator: (value, field, model) => {
              if (model.forestDetails && model.forestDetails.stewardshipPlanExists === 'No') {
                if (model[field.model.split('.')[0]][field.model.split('.')[1]]) {
                  return [];
                }
                return ['Field is required'];
              }
              return [];
            },
            visible: (model) => !model || !model.forestDetails || model.forestDetails.stewardshipPlanExists === 'No'
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate all primary forest management goals</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'forestDetails.primaryGoals',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Improving forest health',
              'Protecting against wildfire',
              'Enhancing wildlife habitat',
              'Establishing new tree plantings',
              'Enhancing tree growth and quality',
              'Restoring native habitats',
              'Income from harvesting timber',
              'Income from non-timber forest products',
              'Controlling invasive species',
              'Trails for hiking and biking',
              'Improving fish habitat',
              'Retaining the land as forest',
              'Providing benefits of trees to the environment (carbon credits)',
              'Maintaining a secluded place to live',
              'Passing on the property to children',
              'Integrate agriculture with my forest',
              'Learning about or studying nature',
              'Building a pond'
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Describe other goals not listed above</span><br/><span class="help-text">(Max 250 characters)</span>',
            model: 'forestDetails.otherGoals',
            styleClasses: 'row',
            max: 250
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate concerns about the forest on the Site</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'forestDetails.forestConcerns',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Dead or dying trees',
              'Disease or insect damage',
              'Tree density',
              'Erosion',
              'Invasive species',
              'Seedling competition or mortality',
              'Wildlife conflicts',
              'Trespassers',
              'Wildfire hazards',
              'Stream health'
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Describe other concerns not listed above</span><br/><span class="help-text">(Max 250 characters)</span>',
            model: 'forestDetails.otherConcerns',
            styleClasses: 'row',
            max: 250
          },
          {
            type: 'input',
            inputType: 'number',
            min: 1,
            max: 9999999,
            label: '<span class="label-name">Acres of forest</span>',
            model: 'forestDetails.acresOfForest',
            styleClasses: 'row',
            validator: (value) => {
              if (value === null) {
                console.debug('Exit forestDetails.acresOfForest validate(): (value === null)');
                return [];
              }

              if (Number.isNaN(value)) {
                console.debug('Exit forestDetails.acresOfForest validate(): Number.isNaN(value)');
                return [];
              }

              if ((value <= 0)) {
                console.warn('Exit forestDetails.acresOfForest validate(): (value <= 0)');
                return ['Must be a whole number greater than 0!'];
              }

              // As originally added by Chris Allport
              // const regex = /^(\d+)?([.]?\d{0,1})?$/;

              // As most recently updated by Russ Frith
              // const regex = /^(\d{0,5})([.]?\d{0,1})$/;
              // if (!regex.test(value)) {
              //   return ['Max 7 digits, up to 1 decimal'];
              // }

              const regex = /^(\d{1,7}?)$/;
              if (!regex.test(value)) {
                console.warn('Exit forestDetails.acresOfForest validate(): !regex.test(value)');
                return ['Must be a whole number 7 digits or less!'];
              }

              return [];
            }
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate all primary tree species</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'forestDetails.primaryTreeSpecies',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Douglas fir',
              'Willamette Valley ponderosa pine',
              'Grand fir',
              'Noble fir',
              'Red alder',
              'Bigleaf maple',
              'Western hemlock',
              'Western red cedar',
              'Oregon white oak',
              'Cottonwood',
              'Oregon ash',
              'Incense-cedar',
              'Madrone',
              'Willow sp.',
              'Other - see notes'
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Forest Notes</span><br/><span class="help-text">(Max 500 characters)</span>',
            model: 'forestDetails.notes',
            styleClasses: 'row',
            max: 500
          },
        ]
      };
    },
    getStreamDetails() {
      return {
        legend: 'Streams',
        headerName: 'Streams',
        fields: [
          {
            type: 'radios',
            label: '<span class="label-name">Is streambank fencing needed?</span><br/><span class="help-text">(Select one)</span>',
            model: 'streamsDetails.fencingNeeded',
            styleClasses: 'row',
            values: [
              'Yes - No funding needed',
              'Yes - Funding needed',
              'No',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Are there potential predation issues from the presence of beaver or elk?</span><br/><span class="help-text">(Select one)</span>',
            model: 'streamsDetails.predationIssues',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
              'Unknown',
              'Not Applicable',
            ]
          },
          {
            type: 'radios',
            label: '<span class="label-name">Indicate the site flooding regime</span><br/><span class="help-text">(Select one)</span>',
            model: 'streamsDetails.floodingRegime',
            styleClasses: 'row',
            values: [
              'Rarely floods',
              'Floods 1 - 2 times per year',
              'Inundated all winter',
              'Unknown',
            ]
          },
          {
            type: 'radios',
            label: '<span class="label-name">Is/are stream crossing(s) available?</span><br/><span class="help-text">(Select one)</span>',
            model: 'streamsDetails.crossingAvailable',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
              'Unknown',
              'Not Applicable',
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">List stream name(s)</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'streamsDetails.names',
            styleClasses: 'row',
            max: 150
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate type(s) of stream on site</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'streamsDetails.typesOfStreams',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Perennial',
              'Ephemeral',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Potential buffer width (ft)</span><br/><span class="help-text">(Select one)</span>',
            model: 'streamsDetails.potentialBufferWidth',
            styleClasses: 'row',
            values: [
              '<50',
              '50-150',
              '>150',
            ]
          },
          {
            type: 'radios',
            label: '<span class="label-name">Level of existing shade</span><br/><span class="help-text">(Select one)</span>',
            model: 'streamsDetails.existingShade',
            styleClasses: 'row',
            values: [
              '<25%',
              '25-50%',
              '>50%',
            ]
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate any artificial modifications to stream</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'streamsDetails.artificalModifications',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Dike',
              'Levee',
              'Berm',
              'Weir',
              'Artificial dam',
              'Culvert',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Streambank conditions</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'streamsDetails.streamBankConditions',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Steep banks',
              'Riprap/structures present',
              'No bank protection from vegetation',
              'Undercut banks',
              'Active bank failures',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Stream channel observations</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'streamsDetails.channelObservations',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Large wood',
              'Deep pools',
              'Headcuts',
              'Point bars',
              'Disconnected from floodplain',
              'Boulders',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Visible passage barriers</span><br/><span class="help-text">(Select one)</span>',
            model: 'streamsDetails.visiblePassageBarriers',
            styleClasses: 'row',
            values: [
              'Present',
              'Absent',
            ]
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Dominant substrate</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'streamsDetails.dominantSubstrate',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Boulder',
              'Cobble',
              'Gravel',
              'Fine sediments'
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Is there a potential for creating or allowing for natural hydrologic processes?</span><br/><span class="help-text">(Select one)</span>',
            model: 'streamsDetails.naturalProcesses',
            styleClasses: 'row',
            values: [
              'No',
              'Yes',
            ]
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Stream Notes</span><br/><span class="help-text">(Max 500 characters)</span>',
            model: 'streamsDetails.notes',
            styleClasses: 'row',
            max: 500
          },
        ],
      };
    },
    getHabitatDetails() {
      return {
        legend: 'Habitat',
        headerName: 'Habitat',
        fields: [
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate all Habitat/Streams conservation goals</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'habitatDetails.conservationGoals',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Control invasive species',
              'Plant native species',
              'Improve upland wildlife habitat',
              'Restore oak habitat',
              'Improve stream habitat',
              'Improve wetland habitat',
              'Improve fish habitat',
              'Build or maintain a pond',
              'Trails for recreation',
              'Compensation for taking land out of production',
              'Improve property values',
              'Mitigate impacts of flooding',
              'Increase hunting opportunities',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Current Site Management</span><br/><span class="help-text">(Select one)</span>',
            model: 'habitatDetails.currentSiteManagement',
            styleClasses: 'row',
            values: [
              'Active cultivation',
              'Chemical fallow',
              'Regular mowing',
              'No active management',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate native riparian spp present</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'habitatDetails.nativeRiparianSpp',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Conifers',
              'Deciduous Trees',
              'Shrubs',
              'Wetland Spp',
              'Herbaceous',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Historic plant community type</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'habitatDetails.historicPlantType',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Oak woodland',
              'Savannah',
              'Wet prairie',
              'Wetland',
              'Upland forest',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Historic plant community condition</span><br/><span class="help-text">(Select one)</span>',
            model: 'habitatDetails.historicPlantCondition',
            styleClasses: 'row',
            values: [
              'Intact',
              'Intact but fragmented',
              'Degraded',
              'Eliminated',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Are there forest stands less than 30 years old and overstocked with a single species?</span><br/><span class="help-text">(Select one)</span>',
            model: 'habitatDetails.forestStands',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Historic hydrology</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'habitatDetails.historicHydrology',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Present and fully functional',
              'Altered but not eliminated',
              'Significantly impaired or eliminated',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Adjacent property has >75% target weed spp</span><br/><span class="help-text">(Select one)</span>',
            model: 'habitatDetails.targetWeedSpp',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
              'Unknown',
              'Not Applicable',
            ],
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Wildlife observations</span><br/><span class="help-text">(Max 250 characters)</span>',
            model: 'habitatDetails.wildlifeObservations',
            styleClasses: 'row',
            max: 250,
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate any wildlife concerns</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'habitatDetails.wildlifeConcerns',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Beaver',
              'Elk',
              'Nutria',
              'Rats',
              'Rabbits',
              'Moles',
              'Squirrels',
              'Deer',
              'Coyote',
              'Mosquitoes',
              'Other insect pest',
              'Other - see notes',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Opportunities for beaver influence</span><br/><span class="help-text">(Select one)</span>',
            model: 'habitatDetails.beaverInfluence',
            styleClasses: 'row',
            values: [
              'Yes, with owner consent',
              'Yes, not discussed with owner',
              'No, compatible with land use but owner not interested',
              'No, not compatible with land use',
              'N/A',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Are vehicles, farm equipment and/or large debris in project?</span><br/><span class="help-text">(Select one)</span>',
            model: 'habitatDetails.equipmentDebris',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
              'Unknown',
              'Not Applicable',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Indicate site accessibility</span><br/><span class="help-text">(Select one)</span>',
            model: 'habitatDetails.siteAccessibility',
            styleClasses: 'row',
            values: [
              'Anytime',
              'Dry season only',
              'ATV only',
              'Other conditional access',
            ],
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Habitat Notes</span><br/><span class="help-text">(Max 500 characters)</span>',
            model: 'habitatDetails.notes',
            styleClasses: 'row',
            max: 500
          },
        ],
      };
    },
    getUrbanDetails() {
      return {
        legend: 'Urban',
        headerName: 'Urban',
        fields: [
          {
            type: 'radios',
            label: '<span class="label-name">Type of urban site</span><br/><span class="help-text">(Select one)</span>',
            model: 'urbanDetails.siteType',
            styleClasses: 'row',
            values: [
              'Single family residential',
              'Multi family residential',
              'HOA',
              'School',
              'Place of worship',
              'Other - see notes',
            ],
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Brief history of the property</span><br/><span class="help-text">(Max 250 characters)</span>',
            model: 'urbanDetails.briefHistory',
            styleClasses: 'row',
            max: 250,
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate all primary landowner/tenant conservation goals</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'urbanDetails.primaryGoals',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Control invasive species',
              'Plant native species',
              'Improve upland wildlife habitat',
              'Improve stream habitat',
              'Improve wetland habitat',
              'Build or maintain a pond',
              'Improve water quality',
              'Improve water conservation',
              'Improve soil health',
              'Create low maintenance landscaping',
              'Create sustainable vegetable gardening',
              'Create community space',
              'Learn about or study urban conservation',
            ],
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Describe other goals not listed above</span><br/><span class="help-text">(Max 250 characters)</span>',
            model: 'urbanDetails.otherConcerns',
            styleClasses: 'row',
            max: 250,
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate any concerns about current health of trees</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'urbanDetails.treeHealthConcerns',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Invasive tree',
              'Dead tree',
              'Diseased tree',
              'Hazardous tree',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Has landowner/tenant contacted an arborist?</span><br/><span class="help-text">(Select one)</span>',
            model: 'urbanDetails.arborist',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Is the site enrolled in the BHCP?</span><br/><span class="help-text">(Select one)</span>',
            model: 'urbanDetails.bhcp',
            styleClasses: 'row',
            values: [
              'Yes',
              'On Waitlist',
              'No - Interested',
              'No - Not Interested',
              'No - Not Eligible',
            ],
          },
          {
            type: 'radios',
            label: '<span class="label-name">Has landowner/tenant worked with a landscape professional to plan/implement any conservation goals?</span><br/><span class="help-text">(Select one)</span>',
            model: 'urbanDetails.professionalPlan',
            styleClasses: 'row',
            values: [
              'Yes',
              'No',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate landowner/tenant preference for implementation</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'urbanDetails.landownerTenantPreference',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Landscape professional - design',
              'Landscape professional - construction',
              'Self',
              'Combination',
              'N/A - TSWCD manages implementation',
              'Other - See notes',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate any water conservation practices installed on site</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'urbanDetails.waterConservationPractices',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Cistern',
              'Rain barrel',
              'Other - see notes',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate any stormwater management practices installed on site</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'urbanDetails.stormwaterPractices',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Rain garden',
              'Filter strip',
              'Ecoroof',
              'Bioswale',
              'Pervious pavers',
              'Private Water Quality Facility',
              'Other - see notes',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate any flooding concerns</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'urbanDetails.floodingConcerns',
            listbox: true,
            styleClasses: 'row',
            values: [
              'Standing water',
              'Surface water runoff',
              'Erosion',
              'Beaver presence',
              'Other - see notes',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate steps taken to address on-site flooding</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'urbanDetails.floodingSteps',
            listbox: true,
            styleClasses: 'row',
            values: [
              'French drain',
              'Sump pump',
              'Sandbags',
              'Physical berm',
              'Other - see notes',
            ],
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Native spp present</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'urbanDetails.nativeSpp',
            styleClasses: 'row',
            max: 150,
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Ornamental spp present</span><br/><span class="help-text">(Max 150 characters)</span>',
            model: 'urbanDetails.ornamentalSpp',
            styleClasses: 'row',
            max: 150,
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Urban Notes</span><br/><span class="help-text">(Max 700 characters)</span>',
            model: 'urbanDetails.notes',
            styleClasses: 'row',
            max: 700,
          },
        ],
      };
    },
    getTechnicalAssistance() {
      return {
        legend: 'Next Steps',
        headerName: 'Technical Assistance and Next Steps',
        fields: [
          {
            type: 'radios',
            label: '<span class="label-name">Indicate landowner/operator\'s next steps</span><br/><span class="help-text">(Select one)</span>',
            model: 'technicalDetails.nextSteps',
            styleClasses: 'row',
            values: [
              'None - not interested',
              'Talk to other stakeholders',
              'Other - see notes',
            ],
          },
          {
            type: 'customDatepicker',
            label: '<span class="label-name">Indicate when next follow-up should occur</span>',
            placeholder: 'Select Date',
            disabledDates: {
              to: moment().toDate(),
            },
            model: 'technicalDetails.dateOfVisit',
            styleClasses: 'row',
            required: true,
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Requests for further technical assistance</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'technicalDetails.furtherAssistance',
            listbox: true,
            styleClasses: 'row',
            required: true,
            values: [
              'Send information',
              'Schedule another site visit',
              'Send to other staff',
            ],
          },
          {
            type: 'customChecklist',
            label: '<span class="label-name">Indicate referrals to partners needed</span><br/><span class="help-text">(Check all that apply)</span>',
            model: 'technicalDetails.referrals',
            listbox: true,
            styleClasses: 'row',
            values: [
              'CWS',
              'ODA',
              'ODF',
              'TRWC',
              'THPRD',
              'BHCP',
              'JWC',
              'NRCS',
              'FSA',
              'OWEB',
              'OWRD',
              'Metro',
              'Other - see Notes',
            ],
          },
          {
            type: 'customRichText',
            label: '<span class="label-name">Technical Assistance Notes</span><br/><span class="help-text">(Max 500 characters)</span>',
            model: 'technicalDetails.notes',
            styleClasses: 'row',
            max: 500,
          },
        ],
      };
    },
  },
};
